/**
 * Board Pack - Executive Governance Hub
 * Contains: Risk Management (ERM) + Board Process Digitisation
 */

import React, { useState } from 'react';
import TabNavigation from '../components/TabNavigation';
import { useModuleAccess } from '../hooks/useModuleAccess';
import { AlertTriangle, FileText, Briefcase } from 'lucide-react';
import RiskManagement from './RiskManagement';
import BoardProcessModule from './board/BoardProcessModule';

const BoardPack = ({ user, onLogout }) => {
  const { isModuleEnabled, loading } = useModuleAccess();
  const [activeModule, setActiveModule] = useState('erm'); // 'erm' or 'board-process'

  return (
    <div className="min-h-screen bg-gray-50">
      <TabNavigation user={user} onLogout={onLogout} />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Board Pack Header */}
        <div className="mb-6">
          <h1 className="text-4xl font-bold text-gray-900 mb-2">Board Governance</h1>
          <p className="text-gray-600">Executive Governance & Board Intelligence Suite</p>
        </div>

        {/* Module Selector */}
        <div className="mb-6 bg-white rounded-xl border-2 border-gray-200 p-2 shadow-sm">
          <div className="flex gap-2">
            {isModuleEnabled('erm') && (
              <button
                onClick={() => setActiveModule('erm')}
                className={`px-5 py-2.5 rounded-lg font-medium transition-all flex items-center gap-2 ${
                  activeModule === 'erm'
                    ? 'bg-red-600 text-white shadow-md'
                    : 'bg-transparent text-gray-700 hover:bg-gray-100'
                }`}
              >
                <AlertTriangle className="w-5 h-5" />
                Risk Management (ERM)
              </button>
            )}
            {isModuleEnabled('board_process') && (
              <button
                onClick={() => setActiveModule('board-process')}
                className={`px-5 py-2.5 rounded-lg font-medium transition-all flex items-center gap-2 ${
                  activeModule === 'board-process'
                    ? 'bg-indigo-600 text-white shadow-md'
                    : 'bg-transparent text-gray-700 hover:bg-gray-100'
                }`}
              >
                <FileText className="w-5 h-5" />
                Board Process Digitisation
              </button>
            )}
          </div>
        </div>

        {/* Active Module Content */}
        {activeModule === 'erm' && isModuleEnabled('erm') && (
          <RiskManagement user={user} onLogout={onLogout} hideNavigation={true} />
        )}

        {activeModule === 'board-process' && isModuleEnabled('board_process') && (
          <BoardProcessModule user={user} />
        )}
      </div>
    </div>
  );
};

export default BoardPack;
